import homeView from './index'
import searchView from './search'
import bookingView from './view'

import model from './services/model'

export default {
  path: 'bookings',
  component: homeView,
  name: 'Private/Bookings',
  redirect: { name: 'Private/Bookings/Search' },
  children: [
    {
      path: 'search',
      component: searchView,
      name: 'Private/Bookings/Search',
      beforeEnter (to, from, next) {
        if (!model.initDataLoaded) model.init().then(res => next())
        else next()
      }
    },
    {
      path: 'view/:Id',
      component: bookingView,
      name: 'Private/Bookings/View'
    }
  ]
}
